var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HomeLayout',[_c('saima',{key:_vm.$i18n.locale+':a',attrs:{"v":"a","saima":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }